import styled from 'styled-components';

/** A one-colour icon: the SVG is a mask over the ink, so the icon takes any colour or token. */
export const SMaskIcon = styled.span<{ $src: string; $size: number; $ink?: string }>`
  display: block;
  flex-shrink: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  background-color: ${({ $ink = 'rgb(var(--ln-content))' }) => $ink};
  -webkit-mask-image: url('${({ $src }) => $src}');
  mask-image: url('${({ $src }) => $src}');
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
`;
